const message = (function () {
  return {
    application: {
      title: 'pd_seo_title',
      desc: 'pd_seo_desc',
      startDate: 'pd_seo_startDate',
      endDate: 'pd_seo_endDate'
    },
    navbar: [{
      text: 'pd_nav_bar',
      href: '#about'
    }, {
      text: 'pd_nav_competition',
      href: '#categories'
    }, {
      text: 'pd_nav_tiemline',
      href: '#timeline'
    }, {
      text: 'pd_nav_prizes',
      href: '#prizes'
    }, {
      text: 'pd_nav_TW',
      href: '#training'
    }, {
      text: 'pd_nav_finalists',
      href: '#finalists'
    }, {
      text: 'pd_nav_faq',
      href: '#faq'
    }, {
      text: 'pd_nav_partners',
      href: '#partners'
    }, {
      text: 'pd_nav_contact',
      href: '#contact'
    }, {
      text: 'pd_nav_careers',
      href: 'https://careers.shopee.sg/',
      target: '_blank'
    }],
    banner: {
      title: 'pd_banner_title',
      sutTitle: 'pd_banner_sutTitle',
      time: 'pd_banner_time',
      endDate: 'pd_banner_endDate',
      registerBtn: 'pd_banner_sign_up',
      registerLink: 'pd_banner_sign_up_link',
    },
    about: {
      title: 'pd_title_about',
      highlight: 'pd_about_subtitle',
      desc: [
        'pd_about_desc_1',
        'pd_about_desc_2',
        'pd_about_desc_3'
      ],
      iconText: [
        'pd_about_text_1',
        'pd_about_text_2'
      ]
    },
    cardList: [{
      title: 'pd_question_title_1',
      desc: 'pd_question_desc_1',
      icon: 'icon_3.svg'
    }, {
      title: 'pd_question_title_2',
      desc: 'pd_question_desc_2',
      icon: 'icon_4.svg'
    }, {
      title: 'pd_question_title_3',
      desc: 'pd_question_desc_3',
      icon: 'icon_5.svg'
    }, {
      title: 'pd_question_title_4',
      desc: 'pd_question_desc_4',
      icon: 'icon_6.svg'
    }],
    objectives: {
      title: "pd_title_objectives",
      text: 'pd_objectives_desc',
      desc: [
        'pd_objectives_desc_1',
        'pd_objectives_desc_2',
        'pd_objectives_desc_3'
      ]
    },
    categories: {
      title: 'pd_title_categories',
      list: [{
        title: 'pd_categories_item_title_1',
        desc: 'pd_categories_item_desc_1',
        explain: 'pd_categories_item_explain_1',
        icon: 'students.png'
      }, {
        title: 'pd_categories_item_title_2',
        desc: 'pd_categories_item_desc_2',
        explain: 'pd_categories_item_explain_2',
        icon: 'open.png'
      }]
    },
    theme: {
      title: 'pd_title_theme',
      desc: 'pd_theme_desc',
      list: [{
      //   title: 'pd_theme_title_1',
      //   desc: 'pd_theme_desc_1'
      // }, {
      //   title: 'pd_theme_title_2',
      //   desc: 'pd_theme_desc_2'
      // }, {
        desc: 'pd_theme_desc_3'
      }]
    },
    judge: {
      title: 'pd_title_judge',
      list: [{
        title: 'pd_judge_item_title_1',
        desc: [
          'pd_judge_item_desc_1_1',
          'pd_judge_item_desc_1_2'
        ]
      }, {
        title: 'pd_judge_item_title_2',
        desc: [
          'pd_judge_item_desc_2_1',
          'pd_judge_item_desc_2_2'
        ]
      }, {
        title: 'pd_judge_item_title_3',
        desc: [
          'pd_judge_item_desc_3_1',
          'pd_judge_item_desc_3_2',
          'pd_judge_item_desc_3_3'
        ]
      }, {
        title: 'pd_judge_item_title_4',
        desc: [
          'pd_judge_item_desc_4_1',
          'pd_judge_item_desc_4_2'
        ]
      }]
    },
    submission: {
      title: 'pd_title_submission',
      content: {
        desc: [
          'pd_submission_desc_1',
          'pd_submission_desc_2'
        ],
        list: [
          'pd_submission_list_1',
          'pd_submission_list_2',
          'pd_submission_list_3',
          'pd_submission_list_4',
          'pd_submission_list_5',
          'pd_submission_list_6'
        ]
      },
      formate: {
        desc: 'pd_submission_formate_desc',
        list: [
          'pd_submission_formate_list_1',
          'pd_submission_formate_list_2'
        ]
      },
      shortlisted: {
        desc: 'pd_submission_shortlisted_desc',
        list: [
          'pd_submission_shortlisted_list_1',
          'pd_submission_shortlisted_list_2'
        ]
      },
      explain: 'pd_submission_explain'
    },
    timeline: {
      title: 'pd_title_timeline',
      list: [{
        title: 'pd_timeline_title_1',
        desc: ['pd_timeline_desc_1']
      }, {
        title: 'pd_timeline_title_2',
        desc: [
          'pd_timeline_desc_2_1',
          'pd_timeline_desc_2_2'
        ]
      }, {
        title: 'pd_timeline_title_3',
        desc: [
          'pd_timeline_desc_3_1',
          'pd_timeline_desc_3_2'
        ]
      }, {
        title: 'pd_timeline_title_4',
        desc: [
          'pd_timeline_desc_4_1',
          'pd_timeline_desc_4_2'
        ]
      }, {
        title: 'pd_timeline_title_5',
        desc: [
          'pd_timeline_desc_5_1',
          'pd_timeline_desc_5_2',
          'pd_timeline_desc_5_3'
        ]
      }, {
        title: 'pd_timeline_title_6',
        desc: [
          'pd_timeline_desc_6_1',
          'pd_timeline_desc_6_2'
        ]
      }, {
        title: 'pd_timeline_title_7',
        desc: ['pd_timeline_desc_7']
      }]
    },
    prizes: {
      title: 'pd_title_prizes',
      desc: 'pd_prizes_desc',
    },
    training: {
      title: 'pd_title_training',
      desc: ['pd_training_desc']
    },
    finalists: {
      title: 'pd_title_finalists',
      desc: ['pd_finalists_desc'],
      btn: 'pd_finalists_btn',
      link: 'https://techatshopee.formstack.com/forms/productdesign_challenge2021'
    },
    faq: {
      title: 'pd_title_faq',
      sections: [{
        title: 'pd_faq_eligibility',
        list: [{
          question: 'pd_faq_eligibility_q1',
          desc: ['pd_faq_eligibility_a1']
        }, {
          question: 'pd_faq_eligibility_q2',
          desc: ['pd_faq_eligibility_a2']
        }, {
          question: 'pd_faq_eligibility_q3',
          desc: ['pd_faq_eligibility_a3_1', 'pd_faq_eligibility_a3_2', 'pd_faq_eligibility_a3_3']
        }, {
          question: 'pd_faq_eligibility_q4',
          desc: ['pd_faq_eligibility_a4']
        }, {
          question: 'pd_faq_eligibility_q5',
          desc: ['pd_faq_eligibility_a5_1', 'pd_faq_eligibility_a5_2']
        }, {
          question: 'pd_faq_eligibility_q6',
          desc: ['pd_faq_eligibility_a6_1', 'pd_faq_eligibility_a6_2']
        }, {
          question: 'pd_faq_eligibility_q7',
          desc: ['pd_faq_eligibility_a7']
        }, {
          question: 'pd_faq_eligibility_q8',
          desc: ['pd_faq_eligibility_a8_1', 'pd_faq_eligibility_a8_2']
        }, {
          question: 'pd_faq_eligibility_q9',
          desc: ['pd_faq_eligibility_a9']
        }]
      }, {
        title: 'pd_faq_competitiony',
        list: [{
          question: 'pd_faq_competitiony_q1',
          desc: ['pd_faq_competitiony_a1_1', 'pd_faq_competitiony_a1_2', 'pd_faq_competitiony_a1_3', 'pd_faq_competitiony_a1_4', 'pd_faq_competitiony_a1_5', 'pd_faq_competitiony_a1_6', 'pd_faq_competitiony_a1_7', 'pd_faq_competitiony_a1_8', 'pd_faq_competitiony_a1_9']
        }, {
          question: 'pd_faq_competitiony_q2',
          desc: ['pd_faq_competitiony_a2']
        }, {
          question: 'pd_faq_competitiony_q3',
          desc: ['pd_faq_competitiony_a3_1', 'pd_faq_competitiony_a3_2']
        }, {
          question: 'pd_faq_competitiony_q4',
          desc: ['pd_faq_competitiony_a4_1']
        }, {
          question: 'pd_faq_competitiony_q5',
          desc: ['pd_faq_competitiony_a5_1', 'pd_faq_competitiony_a5_2']
        }, {
          question: 'pd_faq_competitiony_q6',
          desc: ['pd_faq_competitiony_a6_1', 'pd_faq_competitiony_a6_2']
        }, {
          question: 'pd_faq_competitiony_q7',
          desc: ['pd_faq_competitiony_a7_1']
        }, {
          question: 'pd_faq_competitiony_q8',
          desc: ['pd_faq_competitiony_a8_1']
        }, {
          question: 'pd_faq_competitiony_q9',
          desc: ['pd_faq_competitiony_a9_1']
        }, {
          question: 'pd_faq_competitiony_q10',
          desc: ['pd_faq_competitiony_a10_1']
        }, {
          question: 'pd_faq_competitiony_q11',
          desc: ['pd_faq_competitiony_a11_1']
        }, {
          question: 'pd_faq_competitiony_q12',
          desc: ['pd_faq_competitiony_a12_1', 'pd_faq_competitiony_a12_2']
        }, {
          question: 'pd_faq_competitiony_q13',
          desc: ['pd_faq_competitiony_a13_1', 'pd_faq_competitiony_a13_2', 'pd_faq_competitiony_a13_3']
        }]
      }, {
        title: 'pd_faq_registration',
        list: [{
          question: 'pd_faq_registration_q1',
          desc: ['pd_faq_registration_a1']
        }, {
          question: 'pd_faq_registration_q2',
          desc: ['pd_faq_registration_a2']
        }, {
          question: 'pd_faq_registration_q3',
          desc: ['pd_faq_registration_a3_1', 'pd_faq_registration_a3_2', 'pd_faq_registration_a3_3']
        }, {
          question: 'pd_faq_registration_q4',
          desc: ['pd_faq_registration_a4_1', 'pd_faq_registration_a4_2', 'pd_faq_registration_a4_3']
        }, {
          question: 'pd_faq_registration_q5',
          desc: ['pd_faq_registration_a5_1', 'pd_faq_registration_a5_2', 'pd_faq_registration_a5_3']
        }]
      }, {
        title: 'pd_faq_training',
        list: [{
          question: 'pd_faq_training_q1',
          desc: ['pd_faq_training_a1']
        }, {
          question: 'pd_faq_training_q2',
          desc: ['pd_faq_training_a2']
        }, {
          question: 'pd_faq_training_q3',
          desc: ['pd_faq_training_a3']
        }, {
          question: 'pd_faq_training_q4',
          desc: ['pd_faq_training_a4']
        }, {
          question: 'pd_faq_training_q5',
          desc: ['pd_faq_training_a5']
        }, {
          question: 'pd_faq_training_q6',
          desc: ['pd_faq_training_a6_1', 'pd_faq_training_a6_2']
        }, {
          question: 'pd_faq_training_q7',
          desc: ['pd_faq_training_a7']
        }, {
          question: 'pd_faq_training_q8',
          desc: ['pd_faq_training_a8']
        }, {
          question: 'pd_faq_training_q9',
          desc: ['pd_faq_training_a9']
        }]
      }, {
        title: 'pd_faq_event',
        list: [{
          question: 'pd_faq_event_q1',
          desc: ['pd_faq_event_a1']
        }, {
          question: 'pd_faq_event_q2',
          desc: ['pd_faq_event_a2_1', 'pd_faq_event_a2_2']
        }, {
          question: 'pd_faq_event_q3',
          desc: ['pd_faq_event_a3_1', 'pd_faq_event_a3_2', 'pd_faq_event_a3_3', 'pd_faq_event_a3_4', 'pd_faq_event_a3_5', 'pd_faq_event_a3_6', 'pd_faq_event_a3_7', 'pd_faq_event_a3_8']
        }, {
          question: 'pd_faq_event_q4',
          desc: ['pd_faq_event_a4']
        }, {
          question: 'pd_faq_event_q5',
          desc: ['pd_faq_event_a5']
        }]
      }, {
        title: 'pd_faq_else',
        list: [{
          question: 'pd_faq_else_q4',
          desc: ['pd_faq_else_a4']
        }]
      }]
    },
    partners: {
      title: 'pd_title_partner',
      sections: [{
        title: 'pd_organy_title',
        justifyCenter: true,
        logos: [{
          name: 'Shopee',
          image: 'shopee_logo.png',
          link: 'https://careers.shopee.sg',
          isShopee: true
        }]
      }, {
        title: 'pd_partner_title_schools',
        logos: [{
          name: 'pd_partner_logo_schools_1',
          displayName: 'pd_partner_logo_schools_1',
          link: 'https://www.ntu.edu.sg/cao/Pages/index.aspx'
        }, {
          name: 'pd_partner_logo_schools_2',
          image: 'school_1.png',
          link: 'http://nus.edu.sg/cfg/'
        }, {
          name: 'pd_partner_logo_schools_3',
          image: 'school_2.png',
          link: 'https://www.comp.nus.edu.sg/'
        }, {
          name: 'pd_partner_logo_schools_4',
          image: 'school_3.JPG',
          link: 'http://www.eee.ntu.edu.sg/programmes/mlda/Pages/Home.aspx'
        }, {
          name: 'pd_partner_logo_schools_5',
          image: 'school_4.jpg',
          link: 'http://scse.ntu.edu.sg/Pages/Home.aspx'
        }, {
          name: 'pd_partner_logo_schools_6',
          image: 'school_5.png',
          link: 'https://www.singaporetech.edu.sg/'
        }, {
          name: 'pd_partner_logo_schools_7',
          image: 'school_6.png',
          link: 'https://www.instagram.com/nusstatssoc/'
        }, {
          name: 'pd_partner_logo_schools_8',
          image: 'school_7.jpg',
          link: 'https://www.digipen.edu.sg/?gclid=EAIaIQobChMIz_ytj5ur6QIViwsrCh16wwL8EAAYASAAEgL0afD_BwE'
        }, {
          name: 'pd_partner_logo_schools_9',
          image: 'school_8.jpg',
          link: 'https://firstmedia.edu.sg/'
        }, {
          name: 'pd_partner_logo_schools_10',
          image: 'school_9.png',
          link: 'https://www.fas.nus.edu.sg/'
        }, {
          name: 'pd_partner_logo_schools_11',
          image: 'school_10.png',
          link: 'https://alumni.smu.edu.sg/'
        }, {
          name: 'pd_partner_logo_schools_12',
          image: 'school_11.jpg',
          link: 'http://www.suss.edu.sg/'
        }, {
          name: 'pd_partner_logo_schools_13',
          image: 'school_12.png',
          link: 'http://www.essec.edu/asia'
        }, {
          name: 'pd_partner_logo_schools_14',
          image: 'school_13.png',
          link: 'https://nbs.ntu.edu.sg/'
        }, {
          name: 'pd_partner_logo_schools_15',
          image: 'school_14.png',
          link: 'https://www.madschool.edu.sg/'
        }]
      }, {
        title: 'pd_partner_title_campus',
        logos: [{
          name: 'pd_partner_logo_campus_1',
          image: 'campus_1.png',
          link: 'https://nuscomputing.com/'
        }, {
          name: 'pd_partner_logo_campus_2',
          image: 'campus_2.png',
          link: 'http://sutd-ieee.github.io/'
        }, {
          name: 'pd_partner_logo_campus_5',
          image: 'campus_5.png',
          link: 'https://www.fintechsociety.comp.nus.edu.sg/'
        }, {
          name: 'pd_partner_logo_campus_7',
          image: 'campus_7.png',
          link: 'http://enginclub.com/'
        }, {
          name: 'pd_partner_logo_campus_9',
          image: 'campus_9.png',
          link: 'https://www.iss.nus.edu.sg/'
        }, {
          name: 'pd_partner_logo_campus_10',
          image: 'campus_10.png',
          link: 'https://www.facebook.com/ietntuss/'
        }, {
          name: 'pd_partner_logo_campus_11',
          image: 'campus_11.jpg',
          link: 'http://www.coe.ntu.edu.sg/'
        }, {
          name: 'pd_partner_logo_campus_13',
          image: 'campus_13.jpeg',
          link: 'http://nusieee.org/'
        }, {
          name: 'pd_partner_logo_campus_14',
          image: 'campus_14.jpg',
          link: 'https://www.sutd.edu.sg/'
        }, {
          name: 'pd_partner_logo_campus_15',
          image: 'campus_15.png'
        }, {
          name: 'pd_partner_logo_campus_17',
          image: 'campus_17.jpg',
          link: 'https://www.facebook.com/IES-SUTD-1554216541505233/'
        }, {
          name: 'pd_partner_logo_campus_18',
          image: 'campus_18.png',
          link: 'https://www.facebook.com/nbs.markethinkclub/'
        }, {
          name: 'pd_partner_logo_campus_19',
          image: 'campus_19.png',
          link: 'https://clubs.ntu.edu.sg/ntues/'
        }, {
          name: 'pd_partner_logo_campus_20',
          image: 'campus_20.jpeg',
          link: 'https://nusinvest.com/'
        }, {
          name: 'pd_partner_logo_campus_21',
          image: 'campus_21.png',
          link: 'https://www.biz-strat.org/'
        }, {
          name: 'pd_partner_logo_campus_22',
          image: 'campus_22.png',
          link: 'https://www.instagram.com/simitclub/'
        }, {
          name: 'pd_partner_logo_campus_23',
          image: 'campus_23.png',
          link: 'https://www.sim-yen.com/'
        }, {
          name: 'pd_partner_logo_campus_24',
          image: 'campus_24.jpg',
          link: 'https://www.smublockchain.com/'
        }, {
          name: 'pd_partner_logo_campus_25',
          image: 'campus_25.png',
          link: 'http://www.smueaglesinc.com/'
        }, {
          name: 'pd_partner_logo_campus_26',
          image: 'campus_26.png',
          link: 'http://www.smu-marketing.wixsite.com/smarketing%0d'
        }, {
          name: 'pd_partner_logo_campus_27',
          image: 'campus_27.png',
          link: 'https://www.linkedin.com/company/i-tafa/?viewAsMember=true'
        }, {
          name: 'pd_partner_logo_campus_28',
          image: 'campus_28.png',
          link: 'https://nusbact.com/'
        }, {
          name: 'pd_partner_logo_campus_29',
          image: 'campus_29.png',
          link: 'https://www.singaporetech.edu.sg/studentlife/clubs-and-committees/special-interest/geeks'
        }, {
          name: 'pd_partner_logo_campus_30',
          image: 'campus_30.jpg',
          link: 'https://orientation.smu.edu.sg/vivace/explore/oasics/personal-development/smu-real-business'
        }, {
          name: 'pd_partner_logo_campus_31',
          image: 'campus_31.png'
        }, {
          name: 'pd_partner_logo_campus_32',
          image: 'campus_32.jpg',
          link: 'http://ionssim.co/'
        }]
      }, {
        title: 'pd_partner_title_supporting',
        logos: [{
          name: 'pd_partner_logo_supporting_1',
          image: 'supporting_1.png',
          link: 'https://www.reactor.school/'
        }, {
          name: 'pd_partner_logo_supporting_2',
          image: 'supporting_2.png',
          link: 'https://roboto.sg/'
        }, {
          name: 'pd_partner_logo_supporting_3',
          image: 'supporting_3.png',
          link: 'https://www.safra.sg/interest-groups/safra-entrepreneurs-club'
        }, {
          name: 'pd_partner_logo_training_1',
          image: 'training_1.png',
          link: 'https://generalassemb.ly/'
        }]
      }]
    },
    contact: {
      title: 'pd_title_contact',
      desc: [
        'pd_contact_desc_1',
        'pd_contact_desc_2'
       ],
      btn: 'pd_contact_btn',
      btnLink: 'mailto:techsg@shopee.com'
    },
    footer: {
      follow: 'pd_follow_us',
      links: [[{
        text: 'pd_nav_bar',
        href: '#about'
      }, {
        text: 'pd_nav_competition',
        href: '#competition'
      }, {
        text: 'pd_nav_tiemline',
        href: '#timeline'
      }, {
        text: 'pd_nav_prizes',
        href: '#prizes'
      }], [ {
        text: 'pd_nav_TW',
        href: '#training'
      }, {
        text: 'pd_nav_finalists',
        href: '#finalists'
      }, {
        text: 'pd_nav_faq',
        href: '#faq'
      }, {
        text: 'pd_nav_partners',
        href: '#partners'
      }], [{
        text: 'pd_nav_contact',
        href: '#contact'
      }, {
        text: 'pd_nav_careers',
        href: 'https://careers.shopee.sg/',
        target: '_blank'
      }]],
      tc: 'pdf/terms-and-conditions.pdf',
      privacyPolicy: 'pdf/privacy-policy.pdf'
    }
  }
}(process.env.REACT_APP_COUNTRY))

export default message